// General settings section — org identity, locale, branding.
//
// Layout: each card renders its own header inside the card chrome, matching
// the MembersSection pattern. No stray `<h1>` outside the cards — the
// SettingsShell already renders a PageHeader + tab strip above the Outlet,
// and a per-tab title outside cards reads as a duplicate.
import { createFileRoute } from "@tanstack/react-router";
import { useScrollToAnchor } from "@/features/settings/hooks/use-scroll-to-anchor";
import { useCurrentOrg, useIsOrgAdmin } from "@/stores";
import { IdentityCard } from "@/features/settings/general/components/IdentityCard";
import { LocaleCard } from "@/features/settings/general/components/LocaleCard";
import { BrandingCard } from "@/features/settings/general/components/BrandingCard";

function GeneralSection() {
  useScrollToAnchor();
  const org = useCurrentOrg();
  const canEdit = useIsOrgAdmin();

  if (!org) return null;

  return (
    <div className="space-y-6">
      <IdentityCard org={org} canEdit={canEdit} />
      <LocaleCard org={org} canEdit={canEdit} />
      <BrandingCard org={org} canEdit={canEdit} />
    </div>
  );
}

export const Route = createFileRoute("/_admin/settings/general")({
  component: GeneralSection,
});
